import { requestConstantsMaker } from '../helper';

export const GET_PAYMENT_DETAIL = requestConstantsMaker('GET_PAYMENT_DETAIL');
export const PAY_INVOICE_BY_PAYPAL = requestConstantsMaker('PAY_INVOICE_BY_PAYPAL');